/* eslint-disable */
import React, { useContext, useMemo, useState } from "react";
import { Link as Linker, useHistory, useParams } from "react-router-dom";
import {
  Button,
  Grid,
  Paper,
  Link,
  Typography,
} from "@material-ui/core";
import {
  backgroundStyle,
  btnStyle,
  forgotPasswordStyle,
  h3Style,
  inputStyle,
  labelStyle,
  logoStyle,
  paperStyle,
  pStyle,
} from "./styles";
import { useCountDown } from "hooks/useCountDown";
import { useValidCode } from "hooks/useValidCode";
import { AuthContext } from "../../contexts/authContext";
import { FormControl, OutlinedInput } from "@mui/material";

const VerifyTwoFA: React.FC<any> = () => {
  /* States and context declaration */
  const { firstName, lastName, email, phone }: any = useParams();

  const authContext = useContext(AuthContext);

  /* Callback and Memo, Optimization Section */
  const theme = useMemo(() => {
    return authContext.globalConfig?.theme as undefined;
  }, [authContext]);

  const { code, setCode, codeIsValid } = useValidCode("");
  const [error, setError] = useState("");

  // const navigation = useNavigate();
  const history = useHistory();
  const { seconds, setSeconds, setIsActive } = useCountDown(15);

  /* Generic Error Message */
  const [genericErrorMessage, setGenericErrorMessage] = useState("");

  /* 
  Functions Section 
  */

  const onReSendCodeCallback = (isReSended: boolean) => {
    if (!isReSended) {
      setGenericErrorMessage("Ooops something was wrong please login again");
      setTimeout(function () {
        // navigation("/SignIn");
        history.push("/SignIn");
      }, 4000);
    }
  };

  const onReSendCode = async (e: any) => {
    e.stopPropagation();
    setSeconds(15);
    setIsActive(true);

    try {
      if (authContext.mfaRequired) {
        await authContext.reSendMfaCode(onReSendCodeCallback);
      } else {
        await authContext.reSendCode(email);
      }
    } catch (error: any) {
      setGenericErrorMessage(error.message);
    }
      
  };

  const sendCode = async (e: any) => {
    e.stopPropagation();

    if (code) {
      if (code.length === 0 || code.length > 6) {
        setError("In valid code");
        return;
      }
      try {
        if (authContext.mfaRequired) {
          await authContext.sendMfaCode(email, code);
        } else {
          await authContext.sendCode(email, code);
        }
        setCode("");
        authContext.handleRedirection();
      } catch (error: any) {
        setGenericErrorMessage(error.message);
      }
    }
  };

  return (
    <div style={backgroundStyle}>
      <Grid>
        <Paper elevation={0} style={{ ...paperStyle }}>
          <div style={{ margin: "0px auto" }}>
            <Grid style={logoStyle}>
              <h3 style={h3Style}>2 Factor Authentication</h3>
              <p style={pStyle}>
                We sent an code to the phone number associated with this account.
                Please enter the code below.
              </p>
            </Grid>
            <FormControl sx={{ width: "25ch" }} variant="outlined">
              <OutlinedInput
                id="outlined-adornment-password"
                style={inputStyle}
                type="text"
                value={code}
                onChange={(e: any) => setCode(e.target.value)}
                placeholder="Enter Code"
              />
            </FormControl>
            {/* <TextField
              size="small"
              variant="outlined"
              placeholder="6-digit Code"
              type="password"
              fullWidth
              required
              style={inputStyle}
              onChange={(e: any) => setCode(e.target.value)}
            /> */}
          </div>
          <div style={labelStyle}>
            <Typography>
              Didn't receive ?
              <Link
                onClick={(e: any) => {
                  onReSendCode(e);
                }}
                style={{ ...forgotPasswordStyle, cursor: "pointer" }}
              >
                Resend
              </Link>
            </Typography>
          </div>
        </Paper>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          style={btnStyle}
          fullWidth
          onClick={(e: any) => {
            sendCode(e);
          }}
          disabled={codeIsValid === "" ? false : true}
        >
          Submit
        </Button>
      </Grid>
    </div>
  );
};

export default VerifyTwoFA;
